import React, {
    useState,
    useMemo,
    useEffect,
    useRef,
    useCallback,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    Search,
    CloudUpload,
    Add as PlusIcon,
    Refresh as RefreshIcon
} from '@mui/icons-material'
import {
    Card,
    CardContent,
    TextField,
    Button,
    Typography,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Grid,
    IconButton,
    Stack,
    Tooltip,
    InputAdornment,
    Autocomplete
} from '@mui/material'
import { ExpandMore as ChevronDown } from '@mui/icons-material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { useDebouncer } from '../../hooks/debouncer.hook'
import { useChangeValByserviceID, useCreateTransaction, useDynamicOption, useInputSelectFn, useOnChangeOperation, usePopupSelectFn, useRefreshDependencies } from '../../hooks/dynamicform.hooks'
import { DialogBox } from '../../components/DialogBox/DialogBox'
import TableWithFilter from '../../components/TableWithFilter/TableWithFilter'
import { Get_Val_By_ServiceKey, On_Popup_Table_Search, generateUniqueNumber, removeSpecialCharacters, removeSpecialCharacters_exceptDOT } from '../../globalhelper/DynamicFormHelpers'
import { styled } from '@mui/material/styles'
import CloudUploadIcon from '@mui/icons-material/CloudUpload'
import Popup from '../../components/SimplePOPUP'
import { postRequest } from '../../globalhelper/helper'
import {
    setChangesLog,
    setDOCJSON,
    setDynamicOptionDone,
    setFocusedServiceID,
    setOneSidePDFKey,
    setStoreVals,
    updateValidationErrorByKey
} from '../../redux/DynamicForms/dynamicFormsActions'

dayjs.extend(customParseFormat)

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const DynamicForm = (props) => {
    const { tree, rerender, screenName, onVendorIDonChange, toParent, onOpenChange } = props
    const dispatch = useDispatch()

    // Hooks
    const changeValByserviceID = useChangeValByserviceID()
    const dynamicOption = useDynamicOption()
    const onChange_operation = useOnChangeOperation()
    const debouncer = useDebouncer(1000)
    const inputSelectFn = useInputSelectFn()
    const popup_select_fn = usePopupSelectFn()
    const refreshDependencies = useRefreshDependencies()
    const createTransaction = useCreateTransaction()

    // Redux Selectors (Legacy State)
    const DocJSON = useSelector(state => state.dynamicForms.DOCJSON || [])
    const DOCJSON_root = useSelector(state => state.dynamicForms.DOCJSON || [])
    const ValidationError = useSelector(state => state.dynamicForms.validationError || {})
    const logs = useSelector(state => state.dynamicForms.changesLog || {})
    const vals = useSelector(state => state.dynamicForms.storeVals || {})
    const userData = useSelector(state => state.login.userData || {})
    const dynamicOption_Done = useSelector(state => state.dynamicForms.dynamicOption_Done || {})
    const focusedServiceID = useSelector(state => state.dynamicForms.focusedServiceID)
    const [state, setState] = useState({
        logs: {},
        showPopUP_PDF: false,
        popData_PDF: false,
        fileType: '',
        showSpinner: false,
        dynamicOption: [],
        token: screenName,
        popup_select: [],
        open_popup: false,
        popup_table: null,
        Give_Val_By_ServiceKey: {},
        stop_flag: false,
        selectedVendorName: '',
        selectedLedgerName: '',
        similarity12: 0,
        similarity13: 0,
        similarity23: 0,
        showSimilarityPopup: false,
        similarityresult12: 0,
        showModal: false,
        autoSelected: {},
        billvendorname: '',
        vendorNameAsPerMaster: 'no value',
        vendorLedgerName: '',
        ROW: null,
        localVals: {}
    })

    const {
        popup_table,
        open_popup,
        autoSelected,
        localVals
    } = state

    const base64ToBlob = (base64, mimeType) => {
        const byteArray = Uint8Array.from(atob(base64), (char) =>
            char.charCodeAt(0),
        );
        return new Blob([byteArray], { type: mimeType });
    };

    const tableRow_click = (ROW) => {
        let vendorname = localStorage.getItem("billvendorname");
        console.log("ROW", ROW);

        const selectedVendorName = ROW["Vendor Name As Per Master"];
        const selectedLedgerName = ROW["Vendor Ledger Name"];

        setState((prev) => ({
            ...prev,
            selectedVendorName,
            selectedLedgerName,
            ROW,
        }));

        if (ROW?.["Order Type"] && ROW?.["Order Type"] === "PurchaseOrder") {
            return handlePopupResponse("yes");
        }
        return handleCheckSimilarity(
            vendorname,
            selectedVendorName,
            selectedLedgerName,
        );
    };

    const splitNames = (name) => {
        let cleanedName = name.toLowerCase().replace(/[^a-z0-9\s.-]/g, "");
        cleanedName = cleanedName.replace(/[.-]/g, " ");
        cleanedName = cleanedName.replace(/\s+/g, " ").trim();

        return cleanedName.split(" ");
    };

    const expandAbbreviations = (name) => {
        if (!name) return "";
        const name1 = String(name).toLowerCase();
        const replacements = {
            corp: "corporation",
            pvt: "private",
            ltd: "limited",
        };
        const expandedname = name1.replace(
            /\b(corp|pvt|ltd)\b/g,
            (match) => replacements[match],
        );

        return expandedname;
    };

    const calculateHighestSimilarity = (sourceName, targetName) => {
        try {
            const sourceParts = splitNames(expandAbbreviations(sourceName));
            const targetParts = splitNames(expandAbbreviations(targetName));

            const sourceSet = new Set(sourceParts);
            const targetSet = new Set(targetParts);

            let matchCount = 0;
            for (const word of sourceSet) {
                if (targetSet.has(word)) {
                    matchCount++;
                }
            }
            const totalWords = new Set([...sourceSet, ...targetSet]).size;

            const similarityPercentage = (matchCount / totalWords) * 100;

            return similarityPercentage;
        } catch (error) {
            console.error("Error calculating similarity:", error);
            return 0; // or some default value
        }
    };

    const proceedWithRowClick = () => {
        const ROW = state.ROW;
        if (!ROW) return;

        Object.keys(ROW).forEach((one) => {
            if (ROW[one] !== null) {
                let willStore_val = ROW[one];

                if (screenName === "BillExtract" && one === "TAX") {
                    if (willStore_val === "Non-Taxable") {
                        changeValByserviceID("Tax Category", "serviceKey", "val", "NILL-TAX");
                    }
                }

                changeValByserviceID(one, "serviceKey", "val", willStore_val);
            }
        });

        setState((prev) => ({
            ...prev,
            similarityresult12: prev.similarity12,
            open_popup_select: false,
            open_popup: false,
        }));

        if (rerender) {
            rerender("noQuit");
        }
    };

    const handlePopupResponse = (response) => {
        if (response === "yes") {
            setState((prev) => ({ ...prev, showSimilarityPopup: false }));
            proceedWithRowClick();
        } else {
            setState((prev) => ({ ...prev, showSimilarityPopup: false }));
        }
    };

    // Updated handleCheckSimilarity function to use the new calculateHighestSimilarity logic
    const handleCheckSimilarity = (name1, name2, name3) => {
        const similarity12 = calculateHighestSimilarity(name1, name2);
        const similarity13 = calculateHighestSimilarity(name1, name3);
        const similarity23 = calculateHighestSimilarity(name2, name3);
        if (similarity12 === 100 && similarity13 === 100 && similarity23 === 100) {
            console.log("here");

            setState((prev) => ({
                ...prev,
                similarity12: Math.ceil(similarity12),
                similarity13: Math.ceil(similarity13),
                similarity23: Math.ceil(similarity23),
                showSimilarityPopup: false,
            }));
            handlePopupResponse("yes");
        } else {
            setState((prev) => ({
                ...prev,
                similarity12: Math.ceil(similarity12),
                similarity13: Math.ceil(similarity13),
                similarity23: Math.ceil(similarity23),
                showSimilarityPopup: true,
            }));
            return;
        }
    };

    const openPDF = (e, childrenNode) => {
        e?.preventDefault();
        postRequest(`api/vr2/getPDF_file`, {
            key: childrenNode?.val,
        }).then((res) => {
            if (childrenNode?.subtype === "upload_show") {
                if (res.res.status === "success") {
                    dispatch(setOneSidePDFKey({
                        PDF_KEY: res.res.data,
                        FILE_TYPE: childrenNode?.val.split(".").at(-1) || "pdf"
                    }));
                    onOpenChange?.(true);
                }
                return;
            }
            if (res.res.status === "success") {
                setState((prev) => ({
                    ...prev,
                    showPopUP_PDF: childrenNode.serviceID,
                    popData_PDF: res.res.data,
                    fileType: childrenNode?.val.split(".").at(-1),
                }));
            }
        });
    };

    const onUpload = async (e, childrenNode) => {
        let serviceKey = e.target.name;
        let serviceID = e.target.id;

        let DateTime = dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss");

        let updatedLogs = { ...logs };
        let updatedVals = { ...vals };

        const files = Array.from(e.target.files);
        const totalSize = files.reduce((acc, file) => acc + file.size, 0);

        const MAX_TOTAL_SIZE = 50 * 1024 * 1024; // 50MB

        let file = e.target.files[0];
        if (
            file &&
            e.target.files &&
            e.target.files?.length &&
            files.every((file) => file.name.toLowerCase().includes("pdf")) &&
            Number(MAX_TOTAL_SIZE) > totalSize
        ) {
            let fileName =
                generateUniqueNumber() +
                removeSpecialCharacters_exceptDOT(file.name);

            const Module = localStorage.getItem("module");
            const screenNameClean = removeSpecialCharacters(screenName);
            const fieldName = removeSpecialCharacters(serviceKey);

            let s3key = `UploadedFiles/${Module}/${screenNameClean}/${fieldName}/${fileName}`;

            const formData = new FormData();
            formData.append("file", file);

            postRequest(
                `api/vr2/uploadPDF?module=${localStorage.getItem(
                    "module",
                )}&screenName=${screenNameClean}&fieldName=${fieldName}&fileName=${fileName}`,
                formData,
            ).then((res) => {
                if (res.res.status === "success") {
                    changeValByserviceID(serviceID, "serviceID", "val", s3key);

                    updatedLogs[serviceID] = {
                        serviceKey: serviceKey,
                        serviceID: serviceID,
                        value: s3key,
                        DateTime,
                        scdp: childrenNode?.scdp ? "true" : "false",
                        user: userData?.USR_Email,
                    };
                    updatedVals[serviceID] = s3key;

                    dispatch(setChangesLog(updatedLogs));
                    dispatch(setStoreVals(updatedVals));
                    rerender?.();
                }
            });
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, ""));
        } else if (
            files.every((file) => file.name.toLowerCase().includes("pdf")) &&
            MAX_TOTAL_SIZE <= totalSize
        ) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, `The total size of all files must not exceed 50 MB. Currently: ${(totalSize / (1024 * 1024)).toFixed(2)} MB`));
        } else {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, "This field extension is mismatching"));
        }
    };

    const pendingDynamicOptions = useRef(new Set())

    useEffect(() => {
        if (focusedServiceID) {
            const timer = setTimeout(() => {
                const element = document.getElementById(focusedServiceID);
                if (element) {
                    element.focus();
                    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    dispatch(setFocusedServiceID(null));
                }
            }, 100);
            return () => clearTimeout(timer);
        }
    }, [focusedServiceID, dispatch]);


    useEffect(() => {
        if (!tree.children) return;

        const newDoneKeys = [];
        tree.children.forEach((treenode) => {
            if (treenode.type?.includes('section') && treenode.view === 'form') {
                treenode.children?.forEach((childrenNode) => {
                    if (childrenNode.render === 'true') {
                        if (
                            (childrenNode.type === "select" ||
                                childrenNode.type === "search&select" ||
                                (childrenNode.type === "input" &&
                                    childrenNode.editable === "false") ||
                                childrenNode.type === "multiselect") &&
                            childrenNode.dynamic_option &&
                            childrenNode.dynamic_option.api_Directory &&
                            !dynamicOption_Done.hasOwnProperty(childrenNode.serviceKey) &&
                            !pendingDynamicOptions.current.has(childrenNode.serviceKey)
                        ) {
                            pendingDynamicOptions.current.add(childrenNode.serviceKey);
                            newDoneKeys.push(childrenNode.serviceKey);

                            dynamicOption(childrenNode, childrenNode.serviceKey).finally(() => {
                                // Dynamic option finished
                            });
                        }
                    }
                });
            }
        });

        if (newDoneKeys.length > 0) {
            const updatedDoneKeys = { ...dynamicOption_Done };
            newDoneKeys.forEach(key => {
                updatedDoneKeys[key] = "true";
            });
            dispatch(setDynamicOptionDone(updatedDoneKeys));
        }
    }, [tree, dynamicOption_Done, dispatch, dynamicOption]);

    const instantValidation = useCallback((childrenNode, val) => {
        if (childrenNode.FormatCheck) {
            const regex = new RegExp(childrenNode.FormatCheck);
            const isValid = regex.test(String(val).trim());
            if (!isValid) {
                dispatch(updateValidationErrorByKey(childrenNode.serviceID, `${childrenNode.title} format is invalid`));
            } else {
                dispatch(updateValidationErrorByKey(childrenNode.serviceID, ""));
            }
        }

        if (childrenNode.DateCheck) {
            let checkCase = childrenNode.DateCheck?.includes("_") ? childrenNode.DateCheck.split("_")[0] : childrenNode.DateCheck;
            let targetDateVal = childrenNode.DateCheck?.split("_")[1] ? Get_Val_By_ServiceKey(childrenNode.DateCheck?.split("_")[1], DOCJSON_root) : null;
            let dateA = dayjs(val);
            let dateB = targetDateVal ? dayjs(targetDateVal) : dayjs();
            let isAfter = dateA.isAfter(dateB, "day");
            let isBefore = dateA.isBefore(dateB, "day");

            switch (checkCase) {
                case "isNotFutureDate":
                    if (dayjs(val).isAfter(dayjs(), "day")) {
                        dispatch(updateValidationErrorByKey(childrenNode.serviceID, "Future date is not allowed."));
                    } else {
                        dispatch(updateValidationErrorByKey(childrenNode.serviceID, ""));
                    }
                    break;
                case "isAfter":
                    if (!isAfter) {
                        dispatch(updateValidationErrorByKey(childrenNode.serviceID, `${childrenNode?.["serviceKey"]} should be after ${childrenNode.DateCheck.split("_")[1] || ''}`));
                    } else {
                        dispatch(updateValidationErrorByKey(childrenNode.serviceID, ""));
                    }
                    break;
                case "isBefore":
                    if (!isBefore) {
                        dispatch(updateValidationErrorByKey(childrenNode.serviceID, `${childrenNode?.["serviceKey"]} should be before ${childrenNode.DateCheck.split("_")[1] || ''}`));
                    } else {
                        dispatch(updateValidationErrorByKey(childrenNode.serviceID, ""));
                    }
                    break;
                default:
                    if (!childrenNode.FormatCheck) dispatch(updateValidationErrorByKey(childrenNode.serviceID, ""));
                    break;
            }
        }
    }, [dispatch, DOCJSON_root]);

    const ValidationCondition_fn = useCallback(async (childrenNode, val) => {
        if (!childrenNode.ValidationCondition) return;

        let getValFrom = Get_Val_By_ServiceKey(childrenNode.ValidationCondition.getValFrom[0], DOCJSON_root);

        if (childrenNode.ValidationCondition?.compartor === "<" && ((childrenNode.subtype === "date" && dayjs(val).isBefore(getValFrom)) || (childrenNode.subtype === "number" && val < getValFrom))) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, childrenNode.ValidationCondition?.message));
        } else if (childrenNode.ValidationCondition?.compartor === ">" && (childrenNode.subtype === "date" && dayjs(val).isAfter(getValFrom)) || (childrenNode.subtype === "number" && val > getValFrom)) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, childrenNode.ValidationCondition?.message));
        } else if (childrenNode.ValidationCondition?.compartor === "=" && (childrenNode.subtype === "date" && dayjs(val).isSame(getValFrom)) || ((childrenNode.subtype === "number" || childrenNode.subtype === "text") && val === getValFrom)) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, childrenNode.ValidationCondition?.message));
        } else if (childrenNode.ValidationCondition?.compartor === "!=" && (childrenNode.subtype === "date" && !dayjs(val).isSame(getValFrom)) || ((childrenNode.subtype === "number" || childrenNode.subtype === "text") && val !== getValFrom)) {
            dispatch(updateValidationErrorByKey(childrenNode.serviceID, childrenNode.ValidationCondition?.message));
        }
    }, [DOCJSON_root, dispatch]);

    const myChangeHandler = useCallback((val, serviceKey, serviceID, childrenNode, date = false) => {
        if (date) {
            let formattedDate = dayjs(val, "YYYY-MM-DD").format("DD-MM-YYYY");
            val = formattedDate === "Invalid date" ? val : formattedDate;
        }
        let DateTime = dayjs(new Date()).format("DD-MM-YYYY HH:mm:ss");

        let updatedLogs = { ...logs };
        let updatedVals = { ...vals };

        updatedLogs[serviceID] = {
            serviceKey: serviceKey,
            serviceID: serviceID,
            value: val,
            DateTime,
            scdp: childrenNode?.scdp ? "true" : "false",
            user: userData?.USR_Email,
        };

        updatedVals[serviceID] = val;

        if (childrenNode?.changeAll && childrenNode.changeAll === "true") {
            changeValByserviceID(
                childrenNode?.serviceKey,
                "serviceKey",
                "val",
                val,
                "changeAll"
            );
        } else {
            changeValByserviceID(serviceID, "serviceID", "val", val);
        }

        if (childrenNode.onChange_operation) {
            onChange_operation(childrenNode, val, 0, "", changeValByserviceID)
        }

        dispatch(setChangesLog(updatedLogs));
        dispatch(setStoreVals(updatedVals));
        ValidationCondition_fn(childrenNode, val)
    }, [logs, vals, userData?.USR_Email, changeValByserviceID, onChange_operation, dispatch, ValidationCondition_fn]);

    const autoSelectedRefs = useRef(new Set());

    useEffect(() => {
        if (!tree.children) return;

        tree.children.forEach((treenode) => {
            if (treenode.type?.includes('section') && treenode.view === 'form') {
                treenode.children?.forEach((childrenNode) => {
                    if (
                        childrenNode.render === 'true' &&
                        (childrenNode.type === 'select' || childrenNode.type === 'search&select') &&
                        childrenNode.options?.length === 1
                    ) {
                        const firstOptionValue = childrenNode.options[0].value;
                        const currentVal = String(childrenNode.val || "").trim().toLowerCase();

                        // Auto-select if value is missing, "select", or "select option"
                        if (!childrenNode.val || currentVal === "select" || currentVal === "select option") {
                            // Automatically select the single option ONLY if we haven't already tried to auto-select this
                            if (!autoSelectedRefs.current.has(childrenNode.serviceID)) {
                                autoSelectedRefs.current.add(childrenNode.serviceID);
                                myChangeHandler(firstOptionValue, childrenNode.serviceKey, childrenNode.serviceID, childrenNode);
                            }
                        }
                    }
                });
            }
        });
    }, [tree, myChangeHandler]);

    const on_popup_table_search = (e) => {
        const VAL = e.target.value;
        const result = On_Popup_Table_Search(VAL, state.popup_table);

        if (result) {
            setState(prev => ({
                ...prev,
                popup_table: result,
            }));
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DialogBox title="Transaction Search" open={open_popup} setOpen={() => setState((prev) => ({ ...prev, open_popup: false, open_popup_select: false }))}>
                <TableWithFilter tableData={popup_table} onChange={on_popup_table_search} setState={() => setState((prev) => ({ ...prev, open_popup: false, open_popup_select: false }))} state={state} />
            </DialogBox>

            {state.showSimilarityPopup && (
                <div className="modal-overlay">
                    <div className="modal-box">
                        <table className="table similarity-table">
                            <caption>Match Analysis</caption>
                            <thead>
                                <tr>
                                    <th>% Match</th>
                                    <th>Name As Per</th>
                                    <th>Name As Per</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{state.similarity13?.toFixed(2)}%</td>
                                    <td>Bill [{localStorage.getItem("billvendorname")}]</td>
                                    <td>ERP Ledger [{state.selectedLedgerName}]</td>
                                </tr>
                                <tr>
                                    <td>{state.similarity12?.toFixed(2)}%</td>
                                    <td>Bill [{localStorage.getItem("billvendorname")}]</td>
                                    <td>Vendor Master [{state.selectedVendorName}]</td>
                                </tr>
                                <tr>
                                    <td>{state.similarity23?.toFixed(2)}%</td>
                                    <td>ERP Ledger [{state.selectedLedgerName}]</td>
                                    <td>Vendor Master [{state.selectedVendorName}]</td>
                                </tr>
                            </tbody>
                        </table>

                        <p className="text-center">
                            <em>Do you want to proceed ?</em>{" "}
                            <span>
                                <button onClick={() => handlePopupResponse("yes")}>
                                    Yes
                                </button>
                                <button onClick={() => handlePopupResponse("no")}>
                                    No
                                </button>
                            </span>
                        </p>
                    </div>
                </div>
            )}

            <Accordion
                defaultExpanded
                sx={{
                    mb: 2,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: '12px !important',
                    overflow: 'hidden',
                    '&:before': { display: 'none' },
                    bgcolor: 'background.paper',
                    '&.Mui-expanded': {
                        borderLeft: '4px solid',
                        borderLeftColor: 'primary.main',
                    }
                }}
            >
                <AccordionSummary
                    expandIcon={<ChevronDown sx={{ fontSize: 20 }} />}
                    sx={{
                        bgcolor: '#ffffff',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        py: 0,
                        px: 1.5,
                        minHeight: 36,
                        '&.Mui-expanded': {
                            minHeight: 36,
                        },
                        '& .MuiAccordionSummary-content': {
                            my: 0.5,
                            alignItems: 'center'
                        }
                    }}
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, letterSpacing: '0.01em', color: 'text.primary', fontSize: '0.85rem' }}>
                        {tree.title}
                    </Typography>
                </AccordionSummary>

                <AccordionDetails sx={{ p: 1 }}>
                    {tree.children && tree.children.length > 0 &&
                        tree.children.map((treenode, index) => {
                            if (treenode.type?.includes('section') && treenode.view === 'form') {
                                return (
                                    <Grid container spacing={1.5} key={index} sx={{ mb: 1.5 }}>
                                        {treenode.children?.map((childrenNode, cIndex) => {
                                            if (childrenNode.render === 'true') {
                                                return (
                                                    <Grid item xs={12} md={6} lg={4} key={cIndex}>
                                                        <Stack spacing={0.5}>
                                                            <Tooltip title={childrenNode.tooltip || childrenNode.title} placement="top-start" arrow>
                                                                <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.05em', fontSize: '0.65rem', cursor: childrenNode.tooltip ? 'help' : 'default' }}>
                                                                    {childrenNode.title}
                                                                    {childrenNode.mandatory === 'true' && <Box component="span" sx={{ color: 'error.main', ml: 0.5 }}>*</Box>}
                                                                </Typography>
                                                            </Tooltip>

                                                            <Box>
                                                                {!childrenNode.children &&
                                                                    childrenNode.type === 'input' &&
                                                                    childrenNode.subtype !== 'null' &&
                                                                    childrenNode.subtype !== 'date' &&
                                                                    !childrenNode.subtype?.includes('upload') ? (
                                                                    <Stack direction="row" spacing={0.5} alignItems="center">
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            variant="outlined"
                                                                            type={childrenNode.subtype || 'text'}
                                                                            name={childrenNode.serviceKey}
                                                                            id={childrenNode.serviceID}
                                                                            disabled={childrenNode.editable === "false"}
                                                                            error={!!ValidationError[childrenNode.serviceID]}
                                                                            helperText={ValidationError[childrenNode.serviceID]}
                                                                            value={localVals[childrenNode.serviceID] ?? childrenNode.val ?? ""}
                                                                            onChange={(e) => {
                                                                                const newVal = e.target.value;
                                                                                setState(prev => ({
                                                                                    ...prev,
                                                                                    localVals: { ...prev.localVals, [childrenNode.serviceID]: newVal }
                                                                                }));
                                                                                instantValidation(childrenNode, newVal);
                                                                                rerender?.();
                                                                                debouncer(() => myChangeHandler(newVal, childrenNode.serviceKey, childrenNode.serviceID, childrenNode));
                                                                            }}
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' },
                                                                                    borderRadius: 1.5,
                                                                                    bgcolor: '#fff',
                                                                                    fontSize: '0.8rem',
                                                                                    transition: 'all 0.2s',
                                                                                    '& .MuiOutlinedInput-input': {
                                                                                        py: 1,
                                                                                    },
                                                                                    '&:hover': { bgcolor: '#ffffff' },
                                                                                    '&.Mui-focused': { bgcolor: '#fff', boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.1)' }
                                                                                }
                                                                            }}
                                                                        />
                                                                        {childrenNode.creation_info && (
                                                                            <Tooltip title={`create new ${childrenNode.creation_info.transaction_name}`} arrow>
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => createTransaction(childrenNode)}
                                                                                    sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5 }}
                                                                                >
                                                                                    <PlusIcon sx={{ fontSize: 18, color: 'success.main' }} />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        )}
                                                                    </Stack>
                                                                )
                                                                    : !childrenNode.children && childrenNode.type === 'input_search' ? (
                                                                        <Stack direction="row" spacing={0.5} alignItems="center">
                                                                            <TextField
                                                                                fullWidth
                                                                                size="small"
                                                                                variant="outlined"
                                                                                type={childrenNode.subtype || 'text'}
                                                                                name={childrenNode.serviceKey}
                                                                                id={childrenNode.serviceID}
                                                                                disabled={childrenNode.editable === "false"}
                                                                                error={!!ValidationError[childrenNode.serviceID]}
                                                                                helperText={ValidationError[childrenNode.serviceID]}
                                                                                value={localVals[childrenNode.serviceID] ?? childrenNode.val ?? ""}
                                                                                onChange={(e) => {
                                                                                    const newVal = e.target.value;
                                                                                    setState(prev => ({
                                                                                        ...prev,
                                                                                        localVals: { ...prev.localVals, [childrenNode.serviceID]: newVal }
                                                                                    }));
                                                                                    instantValidation(childrenNode, newVal);
                                                                                    rerender?.();
                                                                                    debouncer(() => myChangeHandler(newVal, childrenNode.serviceKey, childrenNode.serviceID, childrenNode));
                                                                                }}
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-root': {
                                                                                        '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' },
                                                                                        borderRadius: 1.5,
                                                                                        bgcolor: '#fff',
                                                                                        fontSize: '0.8rem',
                                                                                        '& .MuiOutlinedInput-input': {
                                                                                            py: 1,
                                                                                        },
                                                                                        '&:hover': { bgcolor: '#ffffff' }
                                                                                    }
                                                                                }}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end">
                                                                                            <IconButton
                                                                                                size="small"
                                                                                                disabled={childrenNode.editable === "false"}
                                                                                                onClick={(e) => {
                                                                                                    e.preventDefault();
                                                                                                    inputSelectFn(childrenNode, setState, state, on_popup_table_search, tableRow_click);
                                                                                                }}
                                                                                                sx={{ color: 'primary.main' }}
                                                                                            >
                                                                                                <Search sx={{ fontSize: 18 }} />
                                                                                            </IconButton>
                                                                                        </InputAdornment>
                                                                                    )
                                                                                }}
                                                                            />
                                                                            {childrenNode.creation_info && (
                                                                                <Tooltip title={`create new ${childrenNode.creation_info.transaction_name}`} arrow>
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() => createTransaction(childrenNode)}
                                                                                        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5 }}
                                                                                    >
                                                                                        <PlusIcon sx={{ fontSize: 18, color: 'success.main' }} />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            )}
                                                                        </Stack>
                                                                    ) : !childrenNode.children && childrenNode.type === 'input' && childrenNode.subtype === 'date' ? (
                                                                        <Stack direction="row" spacing={0.5} alignItems="center">
                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                <DatePicker
                                                                                    disabled={childrenNode.editable === "false"}
                                                                                    value={(() => {
                                                                                        if (!childrenNode.val) return null;
                                                                                        const formats = ['YYYY-MM-DD', 'DD-MM-YYYY', 'MM/DD/YYYY', 'DD/MM/YYYY', 'YYYY/MM/DD', 'DD MMM YYYY'];
                                                                                        // dayjs will try to parse with the given formats, or fallback to standard ISO 8601 parsing
                                                                                        let d = dayjs(childrenNode.val, formats);
                                                                                        if (!d.isValid()) d = dayjs(childrenNode.val); // Fallback to default parser just in case
                                                                                        return d.isValid() ? d : null;
                                                                                    })()}
                                                                                    inputFormat="YYYY-MM-DD"
                                                                                    onOpen={() => {
                                                                                        console.log(childrenNode.val, '------------------------------------------------------')
                                                                                    }}
                                                                                    onChange={(date) => {
                                                                                        const newVal = date && date.isValid() ? date.format('YYYY-MM-DD') : '';
                                                                                        setState(prev => ({
                                                                                            ...prev,
                                                                                            localVals: { ...prev.localVals, [childrenNode.serviceID]: newVal }
                                                                                        }));
                                                                                        instantValidation(childrenNode, newVal);
                                                                                        rerender?.()
                                                                                        myChangeHandler(newVal, childrenNode.serviceKey, childrenNode.serviceID, childrenNode);
                                                                                    }}
                                                                                    renderInput={(params) => (
                                                                                        <TextField
                                                                                            {...params}
                                                                                            fullWidth
                                                                                            size="small"
                                                                                            id={childrenNode.serviceID}
                                                                                            sx={{
                                                                                                '& .MuiOutlinedInput-root': {
                                                                                                    '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' },
                                                                                                    borderRadius: 1.5,
                                                                                                    bgcolor: '#fff',
                                                                                                    fontSize: '0.8rem',
                                                                                                    '& .MuiOutlinedInput-input': {
                                                                                                        py: 1,
                                                                                                    },
                                                                                                    '&:hover': { bgcolor: '#ffffff' }
                                                                                                }
                                                                                            }}
                                                                                            error={!!ValidationError[childrenNode.serviceID]}
                                                                                            helperText={ValidationError[childrenNode.serviceID]}
                                                                                        />
                                                                                    )}
                                                                                />
                                                                            </LocalizationProvider>
                                                                            {childrenNode.creation_info && (
                                                                                <Tooltip title={`create new ${childrenNode.creation_info.transaction_name}`} arrow>
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() => createTransaction(childrenNode)}
                                                                                        sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5 }}
                                                                                    >
                                                                                        <PlusIcon sx={{ fontSize: 18, color: 'success.main' }} />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            )}
                                                                        </Stack>
                                                                    ) : !childrenNode.children && childrenNode.type === 'textarea' ? (
                                                                        <TextField
                                                                            fullWidth
                                                                            multiline
                                                                            rows={4}
                                                                            size="small"
                                                                            variant="outlined"
                                                                            name={childrenNode.serviceKey}
                                                                            id={childrenNode.serviceID}
                                                                            disabled={childrenNode.editable === "false"}
                                                                            error={!!ValidationError[childrenNode.serviceID]}
                                                                            helperText={ValidationError[childrenNode.serviceID]}
                                                                            value={localVals[childrenNode.serviceID] ?? childrenNode.val ?? ""}
                                                                            onChange={(e) => {
                                                                                const newVal = e.target.value;
                                                                                setState(prev => ({
                                                                                    ...prev,
                                                                                    localVals: { ...prev.localVals, [childrenNode.serviceID]: newVal }
                                                                                }));
                                                                                instantValidation(childrenNode, newVal);
                                                                                rerender?.();
                                                                                debouncer(() => myChangeHandler(newVal, childrenNode.serviceKey, childrenNode.serviceID, childrenNode));
                                                                            }}
                                                                            sx={{
                                                                                '& .MuiOutlinedInput-root': {
                                                                                    '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' },
                                                                                    borderRadius: 1.5,
                                                                                    bgcolor: '#fff',
                                                                                    fontSize: '0.8rem',
                                                                                    '&:hover': { bgcolor: '#ffffff' }
                                                                                }
                                                                            }}
                                                                        />
                                                                    )
                                                                        : !childrenNode.children && (childrenNode.type === 'select' || childrenNode.type === 'search&select') ? (
                                                                            <Stack direction="row" spacing={0.5} alignItems="center">
                                                                                <FormControl fullWidth size="small" error={!!ValidationError[childrenNode.serviceID]}>
                                                                                    <Autocomplete
                                                                                        id={childrenNode.serviceID}
                                                                                        disabled={childrenNode.editable === "false"}
                                                                                        options={childrenNode.options?.filter(opt => opt.value !== '') || []}
                                                                                        getOptionLabel={(option) => typeof option === "string" ? option : (option.label || option.value || "")}
                                                                                        isOptionEqualToValue={(option, value) => option.value === value || option.value === value?.value}
                                                                                        value={
                                                                                            (childrenNode.options || []).find(opt => opt.value === childrenNode.val) ||
                                                                                            (childrenNode.val ? { label: childrenNode.val, value: childrenNode.val } : null)
                                                                                        }
                                                                                        onChange={(e, newValue) => {
                                                                                            const newVal = newValue ? (typeof newValue === "string" ? newValue : newValue.value) : "";
                                                                                            instantValidation(childrenNode, newVal);
                                                                                            myChangeHandler(newVal, childrenNode.serviceKey, childrenNode.serviceID, childrenNode);
                                                                                        }}
                                                                                        renderInput={(params) => (
                                                                                            <TextField
                                                                                                {...params}
                                                                                                error={!!ValidationError[childrenNode.serviceID]}
                                                                                                placeholder="Select Option"
                                                                                                sx={{
                                                                                                    '& .MuiOutlinedInput-root': {
                                                                                                        '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' },
                                                                                                        borderRadius: 1.5,
                                                                                                        bgcolor: '#fff',
                                                                                                        fontSize: '0.8rem',
                                                                                                        py: 0,
                                                                                                        '& .MuiAutocomplete-input': {
                                                                                                            padding: '4px 4px 4px 5px !important'
                                                                                                        },
                                                                                                        '&:hover': { bgcolor: '#ffffff' }
                                                                                                    }
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                                    />
                                                                                    {ValidationError[childrenNode.serviceID] && <Typography variant="caption" color="error" sx={{ mx: 1.5, mt: 0.5 }}>{ValidationError[childrenNode.serviceID]}</Typography>}
                                                                                </FormControl>
                                                                                {childrenNode.creation_info && (
                                                                                    <Tooltip title={`create new ${childrenNode.creation_info.transaction_name}`} arrow>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            onClick={() => createTransaction(childrenNode)}
                                                                                            sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5 }}
                                                                                        >
                                                                                            <PlusIcon sx={{ fontSize: 18, color: 'success.main' }} />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                )}
                                                                                {(childrenNode.dynamic_option) && (
                                                                                    <Tooltip title="Refresh Dependencies" arrow>
                                                                                        <IconButton
                                                                                            size="small"
                                                                                            disabled={childrenNode.editable === "false"}
                                                                                            onClick={() => refreshDependencies(childrenNode, childrenNode.serviceKey)}
                                                                                            sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1.5 }}
                                                                                        >
                                                                                            <RefreshIcon sx={{ fontSize: 18, color: 'primary.main' }} />
                                                                                        </IconButton>
                                                                                    </Tooltip>
                                                                                )}
                                                                            </Stack>
                                                                        ) : childrenNode.children === undefined &&
                                                                            childrenNode.type === "input" &&
                                                                            childrenNode.subtype.includes("upload") ? (
                                                                            <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
                                                                                <Button
                                                                                    disabled={
                                                                                        childrenNode.editable &&
                                                                                        childrenNode.editable === "false"
                                                                                    }
                                                                                    size="small"
                                                                                    component="label"
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    startIcon={<CloudUploadIcon sx={{ fontSize: '1.1rem !important' }} />}
                                                                                    sx={{ textTransform: 'none', py: 0.5, px: 1.5, fontSize: '0.75rem', minHeight: 'unset', borderRadius: 1.5 }}
                                                                                >
                                                                                    Upload
                                                                                    <VisuallyHiddenInput
                                                                                        type="file"
                                                                                        accept=".pdf"
                                                                                        onChange={(e) => {
                                                                                            if (
                                                                                                childrenNode.editable === "true"
                                                                                            ) {
                                                                                                let event = {
                                                                                                    target: {
                                                                                                        id: childrenNode.serviceID,
                                                                                                        name: childrenNode.serviceKey,
                                                                                                        files: e.target.files,
                                                                                                    },
                                                                                                };
                                                                                                onUpload(event, childrenNode);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </Button>

                                                                                {childrenNode.val && (
                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="success"
                                                                                        size="small"
                                                                                        sx={{ textTransform: 'none', py: 0.5, px: 1.5, fontSize: '0.75rem', minHeight: 'unset', borderRadius: 1.5 }}
                                                                                        onClick={(e) =>
                                                                                            openPDF(e, childrenNode)
                                                                                        }
                                                                                    >
                                                                                        Open
                                                                                    </Button>
                                                                                )}

                                                                                {ValidationError[
                                                                                    `${childrenNode.serviceID}`
                                                                                ] && (
                                                                                        <Typography
                                                                                            variant="caption"
                                                                                            color="error"
                                                                                            sx={{ ml: 1 }}
                                                                                        >
                                                                                            {
                                                                                                ValidationError[
                                                                                                `${childrenNode.serviceID}`
                                                                                                ]
                                                                                            }
                                                                                        </Typography>
                                                                                    )}

                                                                                {childrenNode.val &&
                                                                                    state.popData_PDF &&
                                                                                    state.showPopUP_PDF &&
                                                                                    state.showPopUP_PDF ===
                                                                                    childrenNode.serviceID ? (
                                                                                    <Popup
                                                                                        content={
                                                                                            <>
                                                                                                <iframe
                                                                                                    src={
                                                                                                        state.popData_PDF?.startsWith('JVBERi') || state.fileType?.toLowerCase()?.endsWith("pdf")
                                                                                                            ? `data:application/pdf;base64,${state.popData_PDF}`
                                                                                                            : `data:image/${state.fileType || 'jpeg'};base64,${state.popData_PDF}`
                                                                                                    }
                                                                                                    title="pdf-viewer"
                                                                                                    style={{
                                                                                                        width: "100%",
                                                                                                        height: "500px",
                                                                                                    }}
                                                                                                />
                                                                                            </>
                                                                                        }
                                                                                        handleClose={() =>
                                                                                            setState(prev => ({ ...prev, showPopUP_PDF: null }))
                                                                                        }
                                                                                    />
                                                                                ) : null}
                                                                            </Stack>
                                                                        ) : childrenNode.children === undefined && childrenNode.type.includes("popup_select") ? (
                                                                            <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 1 }}>
                                                                                <TextField
                                                                                    fullWidth
                                                                                    size="small"
                                                                                    variant="outlined"
                                                                                    type={childrenNode.subtype}
                                                                                    name={childrenNode.serviceKey}
                                                                                    id={childrenNode.serviceID}
                                                                                    value={childrenNode.val || ""}
                                                                                    disabled
                                                                                    sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' } } }}
                                                                                />
                                                                                <Button
                                                                                    variant="text"
                                                                                    size="small"
                                                                                    onClick={(e) => {
                                                                                        e.preventDefault();
                                                                                        popup_select_fn(childrenNode, setState, state);
                                                                                        setState(prev => ({ ...prev, open_popup_select: true }));
                                                                                    }}
                                                                                    sx={{ textTransform: 'none', minWidth: 'max-content' }}
                                                                                >
                                                                                    <Search />
                                                                                </Button>
                                                                            </Stack>
                                                                        ) : null}

                                                                {childrenNode.children?.map((grandChild, gIndex) => (
                                                                    <Stack direction="row" spacing={1} key={gIndex} sx={{ mt: 1 }}>
                                                                        <Typography variant="body2" sx={{ alignSelf: 'center', fontWeight: 500 }}>{grandChild.title}:</Typography>
                                                                        <TextField
                                                                            fullWidth
                                                                            size="small"
                                                                            variant="outlined"
                                                                            name={grandChild.serviceKey}
                                                                            id={grandChild.serviceID}
                                                                            value={grandChild.val || ""}
                                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 1.5, '&.Mui-disabled': { borderRadius: 1.5, overflow: 'hidden' } } }}
                                                                        />
                                                                    </Stack>
                                                                ))}
                                                            </Box>
                                                        </Stack>
                                                    </Grid>
                                                );
                                            }
                                            return null;
                                        })}
                                    </Grid>
                                );
                            }
                            return null;
                        })
                    }
                </AccordionDetails>
            </Accordion>
        </LocalizationProvider>
    );
}

export default DynamicForm